// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class PharmacyCardFinderPersonName {
    static getAttributeTypeMap() {
        return PharmacyCardFinderPersonName.attributeTypeMap;
    }
}
PharmacyCardFinderPersonName.discriminator = undefined;
PharmacyCardFinderPersonName.additionalProperties = false;
PharmacyCardFinderPersonName.attributeTypeMap = [
    {
        "name": "firstName",
        "baseName": "firstName",
        "type": "string"
    },
    {
        "name": "lastName",
        "baseName": "lastName",
        "type": "string"
    },
    {
        "name": "middleName",
        "baseName": "middleName",
        "type": "string"
    },
    {
        "name": "prefix",
        "baseName": "prefix",
        "type": "string"
    },
    {
        "name": "suffix",
        "baseName": "suffix",
        "type": "string"
    },
];
//# sourceMappingURL=pharmacyCardFinderPersonName.js.map